<!-- eslint-disable -->
<template>
  <div class="dashboard">
    <div ref="top" class="top_margin">
      <div class="top" :class="{ top_fixed: isTopFixed }">
        <p>
          项目阶段:
          <span class="gap-10"></span>
          <span v-for="(item, index) in stage" :key="item.id">
            <span :class="{ 'stage-selected': stageNow === item.id, 'stage-unselected': stageNow !== item.id }" @click="stageChange($event, item.id)">
              {{ item.name }}
            </span>
            <span v-if="index !== stage.length - 1" class="gap-10">|</span>
          </span>
        </p>
        <p>
          项目时间:
          <span class="gap-10"></span>
          <a-range-picker @change="dateChange" :allowClear="false" :default-value="[moment().subtract(7, 'days'), moment()]" />
        </p>
      </div>
    </div>
    <div class="table-overview" v-if="permissions.projectOverview">
      <h3>总览表</h3>
      <a-table
        :loading="overviewLoading"
        :rowKey="
          (record, index) => {
            return index;
          }
        "
        :columns="columnsOverview"
        :data-source="dataOverview"
        size="small"
        style="width: 900px"
        :pagination="false"
      >
        <span slot="user" slot-scope="text">{{ text.nickname }}</span>
      </a-table>
    </div>
    <div class="table-detail" v-if="permissions.projectDetail">
      <h3>细节表</h3>
      <div class="filter-bar">
        <span class="item-label">排序: </span>
        <a-select class="sort" @change="sortChange" v-model="sortedKey">
          <a-select-option v-for="(value, key) in sortFieldMap" :value="key" :key="key">
            {{ value }}
          </a-select-option>
        </a-select>
        <span class="item-label gap-left">项目名: </span>
        <a-input-search v-model="searchName" placeholder="请输入" class="search" @search="handleProjectNameSearch()" />
        <span class="item-label gap-left">DL: </span>
        <a-select class="dl" v-model="DLKey" :allow-clear="true" @change="handleDLChange()">
          <a-select-option v-for="item in DLList" :value="item.id" :key="item.id">
            {{ item.nickname }}
          </a-select-option>
        </a-select>
        <span class="item-label gap-left">项目状态: </span>
        <a-select class="state" v-model="stateKey" :allow-clear="true" @change="handleStateChange()">
          <a-select-option v-for="item in stateList" :value="item.id" :key="item.id">
            {{ item.name }}
          </a-select-option>
        </a-select>
      </div>

      <a-table
        :loading="detailLoading"
        :columns="columnsDetail"
        :data-source="dataDetail"
        size="small"
        :scroll="{ x: stageNow === 1 ? 1888 : 1600 }"
        :pagination="false"
        @change="tableChange"
        :rowKey="
          (record, index) => {
            return index;
          }
        "
      >
        <span slot="createAt" slot-scope="text">{{ moment(text).format('YYYYMMDD') }}</span>
        <span slot="updateAt" slot-scope="text">{{ moment(text).format('YYYYMMDD') }}</span>
        <span slot="priority" slot-scope="text">{{ priorityMap[text] }}</span>
        <a 
          slot="projectName" 
          slot-scope="row" 
          @click="openCompany(row.companyId)"
          data-ga-id="业务推进情况-点击项目名称"
          >
          {{ row.projectName }}
        </a>
        <span slot="dealLeader" slot-scope="text">{{ text.nickname }}</span>
        <span slot="videoPresentation" slot-scope="row">
          <a v-if="row.videoPresentation" @click="toVideoPreview(row)">点击查看</a>
          <span v-else></span>
        </span>

        <span slot="highlight" slot-scope="row">
          <span :class="{ 'notes-item-fold': row.highlight && row.highlight.length > 100 && row.fold['highlight'] }">
            {{ row.highlight }}
          </span>
          <a v-if="row.highlight && row.highlight.length > 100" class="icon-fold" @click="handleFold(row, 'highlight')">
            <span v-if="row.fold['highlight']"><a-icon type="down" />展开</span>
            <span v-else><br /><a-icon type="up" />收起</span>
          </a>
        </span>

        <span slot="keyProblem" slot-scope="row">
          <span :class="{ 'notes-item-fold': row.keyProblem && row.keyProblem.length > 100 && row.fold['keyProblem'] }">
            {{ row.keyProblem }}
          </span>
          <a v-if="row.keyProblem && row.keyProblem.length > 100" class="icon-fold" @click="handleFold(row, 'keyProblem')">
            <span v-if="row.fold['keyProblem']"><a-icon type="down" />展开</span>
            <span v-else><br /><a-icon type="up" />收起</span>
          </a>
        </span>
        <span slot="dealTerm" slot-scope="row">
          <span :class="{ 'notes-item-fold': row.dealTerm && row.dealTerm.length > 100 && row.fold['dealTerm'] }">
            {{ row.dealTerm }}
          </span>
          <a v-if="row.dealTerm && row.dealTerm.length > 100" class="icon-fold" @click="handleFold(row, 'dealTerm')">
            <span v-if="row.fold['dealTerm']"><a-icon type="down" />展开</span>
            <span v-else><br /><a-icon type="up" />收起</span>
          </a>
        </span>
        <span slot="todo" slot-scope="row">
          <span :class="{ 'notes-item-fold': row.todo && row.todo.length > 100 && row.fold['todo'] }">
            {{ row.todo }}
          </span>
          <a v-if="row.todo && row.todo.length > 100" class="icon-fold" @click="handleFold(row, 'todo')">
            <span v-if="row.fold['todo']"><a-icon type="down" />展开</span>
            <span v-else><br /><a-icon type="up" />收起</span>
          </a>
        </span>
      </a-table>
      <div class="pagination">
        <a-pagination
          v-if="pageInfo.total > pageInfo.pageSize"
          v-model="pageInfo.page"
          :total="pageInfo.total"
          :page-size="pageInfo.pageSize"
          @change="pageChange"
          :show-total="total => `总计 ${total} 条`"
        />
      </div>
    </div>
  </div>
</template>
<script>
/* eslint-disable */
import { mapGetters } from 'vuex';
import { projectDetail, projectOverview, stageMemberList } from '@/api/work';
import { financingStageMap, priorityMap } from '@/utils/project';
import { hasPermission } from '@/utils/utils';
import { columnsOverview, columnsDetailAll } from '@/utils/home';
import { stateList } from '@/api/common';
import _ from 'lodash';
import moment from 'moment';

export default {
  data() {
    return {
      overviewLoading: false,
      detailLoading: false,
      dataOverview: [],
      columnsOverview,
      dataDetail: [],
      columnsDetailAll,
      columnsDetail: [],
      sortFieldMap: {},
      sortFieldMapSeed: {
        createAt: '创建时间',
        updateAt: '更新时间',
        compositeScore: '综合分数',
        priority: '优先级',
        marketScore: '市场机会分数',
        teamScore: '团队分数',
        productScore: '产品/技术分数',
        valuationMatchScore: '估值匹配分数'
      },
      sortFieldMapOther: {
        createAt: '创建时间',
        updateAt: '更新时间',
        compositeScore: '综合分数',
        priority: '优先级'
      },
      columnsSeed: [
        'createAt',
        'updateAt',
        'projectName',
        'companyName',
        'companyState',
        'compositeScore',
        'priority',
        'marketScore',
        'teamScore',
        'productScore',
        'valuationMatchScore',
        'dealLeader',
        'dealMembers',
        'brief',
        'keyProblem',
        'dealTerm',
        'todo',
        'highlight',
        'videoPresentation'
      ],
      columnsOther: [
        'createAt',
        'updateAt',
        'projectName',
        'companyName',
        'companyState',
        'compositeScore',
        'priority',
        'dealLeader',
        'dealMembers',
        'brief',
        'keyProblem',
        'dealTerm',
        'todo'
      ],
      sortedInfo: {},
      sortedKey: '',
      pageInfo: {
        page: 1,
        pageSize: 20,
        total: 0,
        isPageChange: false
      },
      timeRange: {
        startTime: '',
        endTime: ''
      },
      stageNow: 0,
      financingStageMap,
      priorityMap,
      permissions: {
        Seed: false,
        Venture: false,
        Growth: false,
        dashboard: false,
        projectOverview: false,
        projectDetail: false
      },
      stage: [],
      isTopFixed: false,
      DLList: [],
      DLKey: [],
      stateKey: [],
      stateList: [],
      sortList: [],
      searchName: ''
    };
  },
  computed: {
    ...mapGetters(['userInfo'])
  },
  watch: {
    sortedInfo(val) {
      let { sortedInfo } = this;
      sortedInfo = sortedInfo || {};

      this.columnsDetail.forEach(_ => {
        _.sortOrder = sortedInfo.columnKey === _.key && sortedInfo.order;
      });

      this.sortedKey = sortedInfo.order ? sortedInfo.columnKey + ' ' + sortedInfo.order : '';
      this.$forceUpdate();

      this.getDetail();
    },
    stageNow(val) {
      // 发请求
      this.getOverview();
      this.getDetail();
      this.getDLList();
      this.getStateList();

      // 改表头
      let tmpFilter = val === 1 ? this.columnsSeed : this.columnsOther;
      this.columnsDetail = this.columnsDetailAll.filter(_ => tmpFilter.includes(_.key));

      // 改排序select
      this.sortFieldMap = {};
      Object.entries(val === 1 ? this.sortFieldMapSeed : this.sortFieldMapOther).forEach(_ => {
        this.sortFieldMap[_[0] + ' ascend'] = _[1] + (_[0] === 'createAt' || _[0] === 'updateAt' ? ' 从远到近' : ' 从低到高');
        this.sortFieldMap[_[0] + ' descend'] = _[1] + (_[0] === 'createAt' || _[0] === 'updateAt' ? ' 从近到远' : ' 从高到低');
      });
    }
  },
  created() {
    this.timeRange['endTime'] = moment().valueOf();
    this.timeRange['startTime'] = moment()
      .subtract(7, 'days')
      .valueOf();

    this.sortedInfo = {
      columnKey: 'createAt',
      field: 'createAt',
      order: 'descend'
    };

    this.getPermissions();

    document.addEventListener('scroll', this.handleScroll);
  },
  beforeDestroyed() {
    document.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    moment,
    handleScroll: _.throttle(function(e) {
      if (this.$refs.top) {
        let offsetTop = this.$refs.top.getBoundingClientRect().top;
        if (offsetTop < 46) {
          this.isTopFixed = true;
        } else {
          this.isTopFixed = false;
        }
      }
    }, 100),
    openCompany(projectId) {
      window.open(window.location.origin + `/project/detail?id=${projectId}`);
    },
    async dateChange(date, dateString) {
      this.$ga.gaUploadCustomEvent('业务推进情况-筛选项目时间');
      this.timeRange['startTime'] = date[0].valueOf();
      this.timeRange['endTime'] = date[1].valueOf();

      this.getOverview();
      this.getDetail();
    },
    async getOverview() {
      if (this.permissions.projectOverview) {
        this.overviewLoading = true;
        let res = await projectOverview({
          page: 1,
          pageSize: 300,
          startTime: this.timeRange['startTime'],
          endTime: this.timeRange['endTime'],
          financingStage: this.stageNow
        });
        if (res.code === 200) {
          this.dataOverview = res.data.list;
        }
        this.overviewLoading = false;
      }
    },
    async getDetail() {
      if (this.permissions.projectDetail) {
        this.detailLoading = true;
        let sortDetail = this.sortedInfo.order
          ? {
              sortField: this.sortedInfo.columnKey,
              order: this.sortedInfo.order === 'ascend' ? 0 : 1
            }
          : {};
        if (this.DLKey) {
          sortDetail['dealLeaderIds'] = this.DLKey;
        }
        if (this.stateKey) {
          sortDetail['stateIds'] = this.stateKey;
        }
        if (!this.pageInfo.isPageChange) {
          this.pageInfo.page = 1;
        }
        let res = await projectDetail({
          startTime: this.timeRange['startTime'],
          endTime: this.timeRange['endTime'],
          financingStage: this.stageNow,
          // 只有翻页的时候请求页码,其他请黄豆回到第一页
          page: this.pageInfo.page,
          pageSize: this.pageInfo.pageSize,
          companyName: this.searchName,
          ...sortDetail
        });

        if (res.code === 200) {
          this.dataDetail = res.data.list;
          this.dataDetail.forEach(_ => {
            _.fold = {};
            let mapTmp = ['highlight', 'keyProblem', 'dealTerm', 'todo'];
            for (let i = 0; i < mapTmp.length; i++) {
              let key = mapTmp[i];
              if (_[key] && _[key].length > 100) {
                _.fold[key] = true;
              }
            }
          });
          this.pageInfo.total = res.data.total;
        }

        this.pageInfo.isPageChange = false;
        this.detailLoading = false;
      }
    },
    async getDLList() {
      let res = await stageMemberList({
        page: 1,
        pageSize: 300,
        financingStage: this.stageNow
      });
      if (res.code === 200) {
        this.DLList = res.data.list;
      }
    },
    async getStateList() {
      let res = await stateList();
      if (res.code === 200) {
        this.stateList = res.data;
      }
    },
    // 筛选change
    stageChange(e, key) {
      this.$ga.gaUploadCustomEvent('业务推进情况-筛选项目阶段',key);
      this.stageNow = key;
      this.sortedInfo = {
        columnKey: 'createAt',
        field: 'createAt',
        order: 'descend'
      };
      this.searchName = '';
      this.DLKey = undefined;
      this.stateKey = undefined;
    },
    // 点击表头排序
    tableChange(pagination, filters, sorter) {
      if (sorter.order) {
        this.sortedInfo = sorter;
      } else {
        this.sortedInfo = {
          columnKey: 'createAt',
          field: 'createAt',
          order: 'descend'
        };
      }
      this.$ga.gaUploadCustomEvent('业务推进情况-选择排序方式【表头】',this.sortedInfo['field']+' '+this.sortedInfo['order']);
    },
    // select框选择排序
    sortChange(e) {
      this.$ga.gaUploadCustomEvent('业务推进情况-选择排序方式',e);
      if (e) {
        let tmp = e.split(' ');
        this.sortedInfo = {
          columnKey: tmp[0],
          field: tmp[0],
          order: tmp[1]
        };
      } else {
        this.sortedInfo = {};
      }
    },
    // 切换分页
    pageChange(page, pageSize) {
      this.pageInfo.page = page;
      this.pageInfo.pageSize = pageSize;
      this.pageInfo.isPageChange = true;
      this.getDetail();
    },
    handleProjectNameSearch() {
      this.$ga.gaUploadCustomEvent('业务推进情况-搜索项目名');
      this.getDetail();
    },
    handleDLChange() {
      this.$ga.gaUploadCustomEvent('业务推进情况-筛选DL');
      this.getDetail();
    },
    handleStateChange() {
      this.$ga.gaUploadCustomEvent('业务推进情况-筛选项目状态',this.stateKey);
      this.getDetail();
    },
    getPermissions() {
      const { permissions:queue } = this.userInfo || {};
      this.permissions.dashboard = hasPermission(queue, '/dashboard');
      this.permissions.Seed = hasPermission(queue, '/dashboard/seed');
      this.permissions.Venture = hasPermission(queue, '/dashboard/venture');
      this.permissions.Growth = hasPermission(queue, '/dashboard/growth');
      this.permissions.projectOverview = hasPermission(queue, '/dashboard/projectOverview');
      this.permissions.projectDetail = hasPermission(queue, '/dashboard/projectDetail');
      this.stage = [];
      if (this.permissions.Seed) {
        this.stage.push({
          id: 1,
          name: 'Seed'
        });
      }
      if (this.permissions.Venture) {
        this.stage.push({
          id: 2,
          name: 'Venture'
        });
      }
      if (this.permissions.Growth) {
        this.stage.push({
          id: 3,
          name: 'Growth'
        });
      }
      this.stageNow = this.stage[0].id;
    },
    handleFold(item, key) {
      item.fold[key] = item.fold[key] === true ? false : true;
      this.$forceUpdate();
    },
    // open a new page to show the url
    toVideoPreview(row) {
      let url = row.videoPresentation;
      let type = row.videoPresentationType;
      if (!this.isHttp(url)) {
        url = 'https://' + url;
      }
      if (this.verifyUrl(url)) {
        // 判断url类型
        // oss的走pdfView,其他的直接打开
        url = type === 0 ? `/pdfview?url=${encodeURIComponent(url)}&type=bpVideo` : url;
        window.open(url);
      } else {
        this.$message.error(`视频链接有误，无法跳转`);
      }
    },
    // 正则判断url是否以http开头
    isHttp(url) {
      return /^http[s]?:\/\//.test(url);
    },
    // use regex to verify whether a url is valid
    verifyUrl(url) {
      return /^(http[s]?|ftp):\/\/([a-zA-Z0-9.-]+(:[a-zA-Z0-9.&%$-]+)*@)*((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9][0-9]?)(\.(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])){3}|([a-zA-Z0-9-]+\.)*[a-zA-Z0-9-]+\.(com|edu|gov|int|mil|net|org|biz|arpa|info|name|pro|aero|coop|museum|[a-zA-Z]{2}))(:[0-9]+)*(\/($|[a-zA-Z0-9.,?'\\+&%$#=~_-]+))*$/.test(
        url
      );
    }
  }
};
</script>
<style lang="less" scoped>
.flex {
  display: flex;
}
.top {
  margin-left: -12px;
  width: 100vw;
  background-color: white;
  z-index: 100;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 12px 0 0 12px;
  transition: all 0.3s ease;
  .stage-selected {
    font-weight: 900;
  }
  .stage-unselected {
    color: rgb(24, 144, 255);
    cursor: pointer;
  }
}
.top_hide {
  opacity: 0;
}
.top_fixed {
  position: fixed;
  top: 46px;
  box-shadow: 0px 0px 15px rgba(0, 0, 0, 0.1);
  p {
    display: inline !important;
  }
}
.top_margin {
  height: 93px;
}
.dashboard {
  position: relative;
  .table-overview {
    margin-bottom: 20px;
  }
  /deep/ .ant-table-column-title {
    font-weight: 500;
  }
}
.table-detail {
  margin-bottom: 24px;
  .filter-bar {
    margin: 12px 0;
    .item-label {
      margin-right: 12px;
    }
    .gap-left {
      margin-left: 28px;
    }
    .sort {
      width: 250px;
    }
    .search {
      width: 300px;
    }
    .dl {
      width: 120px;
    }
    .state {
      width: 140px;
    }
  }
  .pagination {
    width: 100%;
    margin-top: 12px;
    display: flex;
    justify-content: flex-end;
  }
  /deep/ .ant-table-row {
    .dot {
      font-weight: 900;
      margin: 4px 4px 4px 0;
      font-size: 10px;
    }
    .notes-item {
      width: 100%;

      img {
        width: auto;
        height: auto;
        max-width: 80%;
        max-height: 100px;
      }
      p {
        margin: 4px 0;
      }
    }
    .notes-item-unfold {
      // max-height: none;
    }
    .notes-item-fold {
      overflow: hidden;
      text-overflow: ellipsis;
      //显示多行
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 5;
    }
    .icon-fold {
      font-size: 12px;
      i {
        margin-right: 4px;
      }
    }
  }
}
</style>
